import React from "react";
import styles from "./NewPolaroid.module.css";
import { Link } from "react-router-dom";
import PriceCircle from "../Gifts/PriceCircle";
import { ProductsAPI } from "../../Helpers/ConfigProvider";

function NewPolaroid({
  Id,
  Name,
  Images,
  Price,
  FriendlyName,
  hidePrice = false,
  Route = "Products",
  Theme,
}) {
  return (
    <div
      className={styles.polaroid}
      style={{
        borderColor: Theme?.Colour ? Theme.Colour : "var(--mh-yellow-color)",
        backgroundColor: Theme?.Colour ? Theme.Colour : null,
      }}
    >
      <Link to={`/${Route}/${FriendlyName}`}>
        {Images && Images.length > 0 && (
          <img
            src={`${ProductsAPI}${Images[0]?.src}`}
            alt={Name}
            onError={(e) =>
              (e.target.src = "/Images/Content/mh-registered.png")
            }
          />
        )}
        <div className={styles.NamePrice}>
          <p>{Name}</p>
          {!hidePrice && <p className={styles.Price}>£{Price}</p>}
        </div>
      </Link>
    </div>
  );
}

export default NewPolaroid;
